import { render } from "./WechatTemplateView.vue?vue&type=template&id=2d1f59f6&scoped=true"
import script from "./WechatTemplateView.vue?vue&type=script&lang=js"
export * from "./WechatTemplateView.vue?vue&type=script&lang=js"

import "./WechatTemplateView.vue?vue&type=style&index=0&id=2d1f59f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1f59f6"]])

export default __exports__